import type React from 'react';
import { useEffect } from 'react';
import useInput from '@hooks/useInput';
import Button from '@components/Button';
import Modal from '@components/Modal';
import Title from '@components/Title';
import Input from '@components/Input';
import Tip from '@components/Tip';

interface Props {
  oldId?: string;
  isOpen?: boolean;
  onRequestClose: () => void;
  onConfirm: (result: { id: string }) => void;
}

function ThirdPartyModal({
  oldId: oldName,
  isOpen = false,
  onRequestClose,
  onConfirm,
}: Props) {
  const input = useInput<HTMLInputElement>(oldName);
  useEffect(() => {
    input.select();
  }, []);
  const handleConfirm = () => {
    input.select();
    onConfirm({ id: input.value.trim() });
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleConfirm();
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      header={<Title>绑定第三方平台ID</Title>}
      footer={<Button onClick={handleConfirm}>确认操作</Button>}
    >
      <div className="flex h-full flex-col justify-center">
        <Input
          className="h-40 w-full"
          maxLength={500}
          placeholder="请输入第三方平台ID"
          onClear={() => {
            input.clear();
            input.focus();
          }}
          onKeyDown={handleKeyDown}
          {...input.bind}
        />
        <Tip className="mt-5 text-sm text-orange">
          注：通过关联第3方平台ID在接入SDK二次开发时可以更便捷查询到对应场景
        </Tip>
      </div>
    </Modal>
  );
}

export default ThirdPartyModal;
